import * as Yup from "yup";

export const ProjectSchema = Yup.object().shape({
  nickName: Yup.string().required("Nickname is required"),
  projectType: Yup.string().required("Project Type is required"),
  endDate: Yup.date().required("End Date is required"),
  startDate: Yup.date().required("Start Date is required"),
  totalProjectDays: Yup.string().required("Total Project Days is required"),
  workingDays: Yup.array().of(Yup.string()).min(1).required("Working Days is required"),
  contractor: Yup.array().of(
    Yup.object().shape({
      contactPhoneNumber: Yup.string().required("Contact Phone Number is required"),
      contractorName: Yup.string().required("Contractor Name is required"),
      emailAddress: Yup.string().email("Invalid email format").required("Email Address is required"),
      mailingAddress: Yup.string().required("Mailing Address is required"),
      nameOfContact: Yup.string().required("Name of Contact is required"),
      phoneNumber: Yup.string().required("Phone Number is required"),
      website: Yup.string().required("Website is required"),
    })
  ),
  subContractor: Yup.array().of(
    Yup.object().shape({
      contactPhoneNumber: Yup.string().required("Contact Phone Number is required"),
      contractorName: Yup.string().required("Contractor Name is required"),
      emailAddress: Yup.string().email("Invalid email format").required("Email Address is required"),
      mailingAddress: Yup.string().required("Mailing Address is required"),
      nameOfContact: Yup.string().required("Name of Contact is required"),
      phoneNumber: Yup.string().required("Phone Number is required"),
      website: Yup.string().required("Website is required"),
    })
  ),
});
